import Alpine from 'alpinejs';

export default function initAccordion() {
  Alpine.data('accordion', () => ({
    selectedItem: '',
    toggle(id: string) {
      this.selectedItem = this.selectedItem === id ? '' : id;
    },
    isCollapsed(id: string) {
      return this.selectedItem !== id;
    },
  }));
}
